import * as angular from 'angular';

import * as ChecklistPage from './checklist';
import * as ClaimsPage from './claims';
import * as CoveragePage from './coverage';
import * as ErrorPage from './error';
import * as GetMorePage from './get-more';
import * as LoginPage from './login';
import * as LogoutPage from 'common/source/pages/logout';
import * as MessagesPage from './messages';
import * as OverviewPage from './overview';
import * as PaymentsPage from './payments';
import * as PoliciesPage from './policies';
import * as creditCardPaymentMethodPage from '../pages/payments/components/credit-card-payment-method';
import * as escrowPaymentMethodPage from '../pages/payments/components/escrow-payment-method';
import * as achPaymentMethodPage from '../pages/payments/components/ach-payment-method';

const module = angular.module('customerPortalPages', [
    ChecklistPage.module.name,
    ClaimsPage.module.name,
    CoveragePage.module.name,
    ErrorPage.module.name,
    GetMorePage.module.name,
    LoginPage.module.name,
    LogoutPage.module.name,
    MessagesPage.module.name,
    OverviewPage.module.name,
    PaymentsPage.module.name,
    PoliciesPage.module.name,
    creditCardPaymentMethodPage.module.name,
    escrowPaymentMethodPage.module.name,
    achPaymentMethodPage.module.name
]);

export { module };
